module.exports = __webpack_public_path__ + "img/oneliquidity.b6b97faf.png";